export class CountdownTimer {
	dateTime: CountdownTimerDateTime;
	styles: CountdownTimerStyles;
}

export class CountdownTimerDateTime {
	date: string;
	time: string;
	timezone: string;
}

export class CountdownTimerStyles {
	fontFamily: string;
	fontSize: number;
	fontColor: string;
	backgroundColor: string;
	backgroundImage: string;
	layout: TIMER_LAYOUT_ENUM;
	customLayoutAllowed?: boolean;
}

export enum TIMER_LAYOUT_ENUM {
	default = 1,
	overlay,
	modern
}
